import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from 'store/store'
import {
  OrderCreateInputType,
  OrderRateInputType,
  OrderVariantInputType,
} from 'lib/types/custom'
import {
  CalendarInput,
  ContactOfRepresentativeInput,
  OrderPurpose,
} from 'lib/graphql/storefront'

const initialState: OrderCreateInputType = {
  bookingDate: { start: '', end: '' },
  productVariants: [],
  numberOfPeople: 1,
  contactOfRepresentative: {
    name: '',
    email: '',
    phone: '',
  },
  purpose: null,
  saleOfGoods: false,
  entryFee: false,
  calendar: {
    approval: false,
    organizer: '',
    eventName: '',
    publishableDate: null,
  },
  rate: {
    variantId: '',
    period: {
      start: '',
      end: '',
    },
  },
}

// Slice
const OrderCreateInputSlice = createSlice({
  name: 'facility',
  initialState,
  reducers: {
    setOrderStartDates: (state, action: PayloadAction<string>) => {
      const { payload } = action
      state.bookingDate.start = payload
    },
    setOrderEndDates: (state, action: PayloadAction<string>) => {
      const { payload } = action
      state.bookingDate.end = payload
    },
    setOrderProductVariants: (
      state,
      action: PayloadAction<OrderVariantInputType[]>
    ) => {
      const { payload } = action
      state.productVariants = payload
    },
    setOrderNumberOfPeople: (state, action: PayloadAction<number>) => {
      const { payload } = action
      state.numberOfPeople = payload
    },
    setContactOfRepresentative: (
      state,
      action: PayloadAction<ContactOfRepresentativeInput>
    ) => {
      const { payload } = action
      state.contactOfRepresentative = payload
    },
    setOrderPurpose: (state, action: PayloadAction<OrderPurpose>) => {
      const { payload } = action
      state.purpose = payload
    },
    setOrderSaleOfGoods: (state, action: PayloadAction<boolean>) => {
      const { payload } = action
      state.saleOfGoods = payload
    },
    setOrderEntryFee: (state, action: PayloadAction<boolean>) => {
      const { payload } = action
      state.entryFee = payload
    },
    setOrderCalendar: (state, action: PayloadAction<CalendarInput>) => {
      const { payload } = action
      state.calendar = payload
    },
    setOrderRate: (state, action: PayloadAction<OrderRateInputType>) => {
      const { payload } = action
      state.rate = payload
    },
    resetOrderInput: () => {
      return initialState
    },
  },
})

// Selectors
export const getOrderCreateInputSelector = (
  state: RootState
): OrderCreateInputType => state.orderCreateInput

export const getOrderProductVariantsSelector = (
  state: RootState
): OrderVariantInputType[] => state.orderCreateInput.productVariants

// Actions
export const {
  setOrderStartDates,
  setOrderEndDates,
  setOrderProductVariants,
  setOrderNumberOfPeople,
  setContactOfRepresentative,
  setOrderPurpose,
  setOrderSaleOfGoods,
  setOrderEntryFee,
  setOrderCalendar,
  setOrderRate,
  resetOrderInput,
} = OrderCreateInputSlice.actions

// Reducers
export default OrderCreateInputSlice.reducer
